export const DashboardAccessLevel = {
  ALLOWED: 0,
  LIMITED: 1,
  BLOCKED: 2,
}
